import { useAuth } from "../context/auth";
import { Navigate, Outlet } from "react-router";
import Loading from "../components/Loading";

export default function SignedRoutes() {
    const auth = useAuth();
    if(auth.loading) {
        return (
            <Loading />
        )
    }
    return auth.signed ? <Outlet /> : <Navigate to="/login" />
}